import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { getFormTemplates, getFormTemplatesResponseModel } from '../../../services/form/FormService';

interface Values {
  isLoading: boolean;
  formTemplates: getFormTemplatesResponseModel | undefined;
  setOrganizationId: Dispatch<SetStateAction<string | undefined>>;
}

interface FormTemplateData {
  data: getFormTemplatesResponseModel;
  page: number;
  pageSize: number;
  totalCount: number;
}

const useFormTemplates = (organizationId?: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [formTemplates, setFormTemplates] = useState<getFormTemplatesResponseModel>();
  const [id, setOrganizationId] = useState<string | undefined>(organizationId);

  useEffect(() => {
    setIsLoading(true);
    loadAsync();
  }, [id]);

  const loadAsync = async () => {
    try {
      if (id) {
        const form = await getFormTemplates(id, 1, 12);
        const formTemplates = form.data as unknown as FormTemplateData;
        if (form.data) {
          setFormTemplates(formTemplates.data || []);
        }
      }
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { formTemplates, isLoading, setOrganizationId };
};

export default useFormTemplates;
